(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */
  angular
    .module('perfis', [
      'ui.router',
      'ui.bootstrap.modal',
      'flash'
    ]);
}());
